import { useTranslations } from '@i18n/useLanguage'
import { MegaMenuLinks } from '../blocks/common'
import {
  faBookOpenReader,
  faGraduationCap,
  faQuoteLeft,
} from '@fortawesome/pro-solid-svg-icons'
import { MegaMenuGrid } from '../blocks/MegaMenuGrid'
import { TextLink } from '@app/components/core/link/TextLink'
import Column from '@app/components/layout/Column'

const LearnMenu = () => {
  const t = useTranslations().app.nav.megaMenu.learnMenu

  return (
    <MegaMenuGrid
      columns={[
        {
          items: [
            {
              to: MegaMenuLinks.knowledgeHub,
              icon: faBookOpenReader,
              label: t.knowledgeHub.label,
              description: t.knowledgeHub.description,
              backgroundColor: 'var(--palette-yellow-300)',
              children: (
                <Column gap="1rem" style={{ paddingLeft: '4rem' }}>
                  <TextLink
                    size="small"
                    to={MegaMenuLinks.whoWorksArticle}
                    containerStyle={{ textDecoration: 'none' }}
                  >
                    {t.knowledgeHub.links.whatCanIDo}
                  </TextLink>
                  <TextLink
                    size="small"
                    to={MegaMenuLinks.whowToMakeAccountArticle}
                    containerStyle={{ textDecoration: 'none' }}
                  >
                    {t.knowledgeHub.links.createAccount}
                  </TextLink>
                  <TextLink
                    size="small"
                    to={MegaMenuLinks.howtoStartProjectArticle}
                    containerStyle={{ textDecoration: 'none' }}
                  >
                    {t.knowledgeHub.links.startInitiative}
                  </TextLink>
                </Column>
              ),
            },
          ],
        },
        {
          items: [
            {
              to: MegaMenuLinks.elearning,
              icon: faGraduationCap,
              label: t.elearning.label,
              description: t.elearning.description,
              backgroundColor: 'var(--palette-pink-200)',
            },
            {
              to: MegaMenuLinks.blog,
              icon: faQuoteLeft,
              label: t.stories.label,
              description: t.stories.description,
              backgroundColor: 'var(--palette-blue-100)',
            },
          ],
        },
      ]}
    />
  )
}

export default LearnMenu
